/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, ReactNode, useEffect } from "react";
import { getSocket } from "../utils/socket.io/socketIOUtils";
import { useSocketIO } from "../hooks/useSocketIO";
import { useSocketIOStore } from "../hooks/stores/useSocketStore";

export const WebsocketContext = createContext<null>(null);

type WebSockerProvider = {
  children: ReactNode;
};

export const WebsocketProvider = ({ children }: WebSockerProvider) => {
  const setSocket = useSocketIOStore((state) => state.setSocket);
  const reset = useSocketIOStore((state) => state.reset);
  const startConnection = useSocketIOStore((state) => state.startConnection);
  const { initialiseListeners } = useSocketIO();

  useEffect(() => {
    const socket = getSocket();
    if (!socket) {
      console.log("RTPATH not defined");
      return;
    }

    console.log("Connecting socket...");
    setSocket(socket);
    startConnection();
    const cleanupListeners = initialiseListeners(socket);
    socket.connect();

    return () => {
      cleanupListeners();
      socket.disconnect();
      reset();
    };
  }, []);

  return (
    <WebsocketContext.Provider value={null}>
      {children}
    </WebsocketContext.Provider>
  );
};
